"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6873],{

/***/ 16873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13886);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_getStoreType__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66871);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26706);






var SSRadioGroup = function(param) {
    var itemList = param.itemList, activeIdx = param.activeIdx, onChange = param.onChange, _itemLowQty = param.itemLowQty, itemLowQty = _itemLowQty === void 0 ? 0 : _itemLowQty;
    var isVariantHidden = function isVariantHidden(item) {
        return (item === null || item === void 0 ? void 0 : item.status) === _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ITEM_ACTIVE_STATUS.HIDDEN */ .p4.HIDDEN;
    };
    var storeInfo = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_4__/* .useSSRSelector */ .kF)(function(state) {
        return {
            storeInfo: state.storeReducer.store
        };
    }).storeInfo;
    var theme = storeInfo.theme;
    var isB2bStore = (0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_3__/* .getStoreType */ .K)(storeInfo) === _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B;
    var checkLimitedQty = function(el) {
        return !!(el === null || el === void 0 ? void 0 : el.managed_inventory) && !!itemLowQty && (el === null || el === void 0 ? void 0 : el.available_quantity) <= itemLowQty;
    };
    var checkIfItemIsOutOfStock = function(el) {
        if (!!(el === null || el === void 0 ? void 0 : el.managed_inventory)) {
            return el.available === 0 && el.available_quantity === 0;
        }
        return el.available === 0;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "single-select-radio-groups",
        children: itemList && (itemList === null || itemList === void 0 ? void 0 : itemList.map(function(el, ind) {
            var ref, ref1, ref2, ref3;
            return !isVariantHidden(el) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
                className: "radio-item ".concat(checkIfItemIsOutOfStock(el) && "out-of-stock", " ").concat(ind === activeIdx && "active", " flex justify-between items-center pointer"),
                onClick: function() {
                    return onChange(ind, el);
                },
                style: {
                    color: "".concat(ind !== activeIdx ? "#000" : theme ? theme === null || theme === void 0 ? void 0 : (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.primary_color : "#EA5151"),
                    borderColor: "".concat(ind !== activeIdx ? "#DEDEDE" : theme ? theme === null || theme === void 0 ? void 0 : (ref1 = theme.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color : "#EA5151")
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex-auto flex justify-start items-center",
                        children: [
                            el.images && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: el === null || el === void 0 ? void 0 : (ref2 = el.images) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.image_url,
                                className: "img h3"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-100 ml3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "fw5 ".concat(checkLimitedQty(el) ? "mt0 mb1" : "mt1 mb2"),
                                        children: el.variant_name
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: "mv1 black",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "fw4",
                                                children: [
                                                    "₹",
                                                    el === null || el === void 0 ? void 0 : el.discounted_price
                                                ]
                                            }),
                                            (el === null || el === void 0 ? void 0 : el.discounted_price) < (el === null || el === void 0 ? void 0 : el.price) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "strike ml2 f7 black-50 fw4",
                                                children: [
                                                    "₹",
                                                    el === null || el === void 0 ? void 0 : el.price
                                                ]
                                            })
                                        ]
                                    }),
                                    !isB2bStore && checkLimitedQty(el) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "highlighter-red-color inventory-change fw4",
                                        children: el.available_quantity ? "Hurry! Only ".concat(el.available_quantity, " units left!") : "Out of stock"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "radio",
                        name: "variant-group",
                        checked: ind === activeIdx,
                        className: "h1 w1"
                    })
                ]
            }, "variant-list-modal-".concat(ind));
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SSRadioGroup);


/***/ })

}]);